import React, { type FC, useEffect, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { ModalFooter } from "../components/layout/ModalProvider";

export const AddInspectionAttachmentsModal: FC<{
  inspection: Inspection;
  onFinished?: () => void;
}> = (props) => {
  const { addAttachments } = useApiCall();
  const [files, setFiles] = useState<File[]>([] as File[]);
  const [errors, setErrors] = useState<string[]>([]);
  const save = async () => {
    await addAttachments(props.inspection.id, files).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    props.onFinished?.();
  };
  useEffect(() => {
    Promise.all(files.map((file) => file.arrayBuffer())).then((buffers) => {
      if (buffers.some((b) => b.byteLength > 20 * 1024 * 1024)) {
        setErrors(["Bestand is te groot (max. 20MB)"]);
        return;
      } else if (buffers.reduce((total, b) => total + b.byteLength, 0) > 100 * 1024 * 1024) {
        setErrors(["Bestanden zijn bij elkaar groter dan 100MB"]);
        return;
      } else if (buffers.length >= 100) {
        setErrors(["Je kunt maximaal 99 bestanden tegelijkertijd uploaden"]);
        return;
      } else {
        setErrors([]);
      }
    });
  }, [files]);
  return (
    <div>
      <label className={`flex flex-col text-sm font-medium text-brand-900 w-full`}>
        <input
          type={"file"}
          multiple={true}
          accept={"application/pdf"}
          className={`border-2 border-slate-200 outline-brand-700 text-black rounded-sm text-base font-normal px-2 py-1 mt-1 min-h-10 w-full`}
          onChange={(e) => setFiles(e.target.files ? Array.from(e.target.files) : [])}
        />
      </label>
      {errors.length > 0 && (
        <div className={"text-red-600 text-sm"}>
          {errors.map((e, i) => (
            <p key={i}>{e}</p>
          ))}
        </div>
      )}
      <div
        className={
          "bg-amber-100 mt-4 border-2 border-amber-200 text-amber-900 mb-4 text-sm rounded-lg px-4 py-3"
        }
      >
        <h2 className={"font-bold"}>Let op</h2>
        Bijlages moeten in PDF formaat zijn, en mogen maximaal 20MB zijn.
      </div>

      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
